import { NgModule } from '@angular/core';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from "./login.component";
import { LoginControlComponent } from './login-control.component';
import { LoginDialogComponent } from './login-dialog.component';
import { AuthService } from '../../services/auth.service';
import { SharedModule } from '../../shared.module';
import { FormBuilder } from '@angular/forms';

@NgModule({
  declarations: [LoginComponent, LoginControlComponent, LoginDialogComponent],
  imports: [
    LoginRoutingModule,
    SharedModule
  ],
  providers: [AuthService, FormBuilder]
})
export class LoginModule { }
